import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getChallengeByPhaseBlock } from "../../slices/challengeSlice";
import { listChallengeWithStatus } from "../../slices/challengeAnswerSlice";
import { profile } from "../../slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import Swal from "sweetalert2";
import phases from '../../utils/phases';

// Import images
import bgImageGame from "../../assets/images/backgroundMapCartoon1024.png";
import estrela from "../../assets/images/estrela.png";
import estrelaFechada from "../../assets/images/estrelafechada.png";
import estrelaVerde from "../../assets/images/estrelacumprida.png"; // Ícone para desafio concluído
import adultboy from "../../assets/images/adultBoy.png";

const Progress = () => {
  const dispatch = useDispatch();
  const { challengeAnswer, loading: loadingAnswers } = useSelector((state) => state.challengeAnswer);
  const { user } = useSelector((state) => state.user);

  const [swalShown, setSwalShown] = useState(false);
  const [challengeId, setChallengeId] = useState(null);
  const [isDataReady, setIsDataReady] = useState(false);
  const phaseBlock = 1;

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(profile()).unwrap();
        await dispatch(listChallengeWithStatus({ userId: user._id })).unwrap();
        setIsDataReady(true); // Marca como pronto após as ações serem concluídas
      } catch (error) {
        console.error("Erro ao carregar dados do usuário/desafios", error);
      }
    };

    fetchData();
  }, [dispatch, user._id]);

  const handleChallenge = async (phase) => {
    try {
      const challengeData = await dispatch(
        getChallengeByPhaseBlock({ phase, block: phaseBlock })
      ).unwrap();
      setChallengeId(challengeData._id);
      Swal.fire({
        title: `<h2 class="font-special font-bold">${challengeData.title}</h2><p class="font-special text-red text-sm">Nível de dificuldade: ${challengeData.difficulty}</p>`,
        html: `<img class="w-28 float-left" src="${adultboy}"><p class="font-special mb-5">${challengeData.description}</p><div id="swal-challenge-link"></div>`,
        showConfirmButton: false,
        background: "#f0f0f0",
        didOpen: () => {
          setSwalShown(true);
        },
        didClose: () => {
          setSwalShown(false);
        },
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao carregar o desafio",
        text: "Ocorreu um problema ao buscar o desafio.",
        showConfirmButton: true,
      });
    }
  };

  // Exibe um carregando enquanto os dados não estão prontos
  if (!isDataReady || loadingAnswers) {
    return <p className="text-white text-center mt-10">Carregando...</p>;
  }

  return (
    <div
      className="relative flex items-center justify-center h-screen w-screen"
      style={{
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
      }}
    >
      <div className="absolute inset-0 backdrop-blur-sm"></div>
      <motion.h1
        className="font-special text-4xl text-white"
        style={{
          position: "absolute",
          top: "10%",
          width: "100vh",
          textAlign: "center",
        }}
      >
        Selecione o desafio da semana
      </motion.h1>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative z-10 flex items-center justify-center"
        style={{
          width: "1024px",
          height: "520px",
          position: "absolute",
          backgroundImage: `url(${bgImageGame})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          border: "8px solid #4B3A33",
          transformOrigin: "top left",
          boxShadow: "0 0 0 8px #3b2f29, 0 0 10px rgba(0, 0, 0, 0.5), inset 0 0 8px rgba(2055, 255, 255, 0.3)",
        }}
      > 
        {phases.map((phase, index) => {
          const relatedChallenge = challengeAnswer?.find(
            (answer) => answer.phase === index + 1
          );
          const isCompleted = relatedChallenge?.isCompleted || false;

          return (
            <>
              {user.currentPhase === index + 1 && user.currentBlock === phaseBlock && (
                <motion.img
                  style={{
                    maxHeight: "100px",
                    position: "absolute",
                    top: phase.avatar,
                    left: phase.left,
                    zIndex: "100",
                  }}
                  whileHover={{ scale: 1.1 }}
                  onClick={!isCompleted ? () => handleChallenge(index + 1) : null}
                  src={adultboy}
                  alt="Jogador"
                />
              )}
              <span
                onClick={
                  !isCompleted &&
                  user.currentPhase >= index + 1 &&
                  user.currentBlock >= phaseBlock
                    ? () => handleChallenge(index + 1)
                    : null
                }
                className="rounded-full"
                style={{
                  position: "absolute",
                  top: phase.top,
                  left: phase.left,
                  backgroundSize: "cover",
                  backgroundImage: isCompleted
                    ? `url(${estrelaVerde})`
                    : user.currentPhase >= index + 1 && user.currentBlock >= phaseBlock
                    ? `url(${estrela})`
                    : `url(${estrelaFechada})`,
                  padding: "4px",
                  width: "30px",
                  height: "30px",
                  cursor: isCompleted ? "not-allowed" : "pointer",
                }}
              ></span>
            </>
          );
        })}
      </motion.div>
      {swalShown &&
        createPortal(
          <Link
            to={`/Challenge/${challengeId}`}
            className="font-special font-bold text-white bg-dour-suave rounded-full p-2 mt-2 cursor-pointer"
            onClick={() => Swal.close()}
          >
            Ir para o Desafio
          </Link>,
          document.getElementById("swal-challenge-link")
        )}
    </div>
  );
};

export default Progress;
